<template>
  <div>
    <v-row class="justify-end">
      <v-spacer />
      <QuotationFloatActionButton
        class="messageInfoProposal"
        v-if="!getIsEmployeeUser"
        :message="infoMessage"
      />
    </v-row>
    <v-row>
      <v-col cols="12" md="6" class="pr-md-5 pb-md-12">
        <v-row
          class="px-4 pt-3 pb-4 details-proposal__card "
          v-bind:class="quotationCafezal"
        >
          <v-col cols="12">
            <p class="primary--text font-weight-bold">
              Dados de Identificação
            </p>
          </v-col>
          <v-col cols="12" class="mb-3 details-proposal__item">
            <v-row class="pa-4 pt-4" v-if="!isPolicy">
              <v-col cols="12" sm="6" class="pb-sm-0 pr-sm-5">
                <p
                  class="body-2 font-weight-bold primary--text mb-0 details-proposal__title-height"
                >
                  Número da Proposta
                </p>
                <p
                  class="darkBluishGray--text mb-2 font-weight-medium details-proposal__text-height"
                >
                  {{ form.numero_proposta }}
                </p>
              </v-col>
              <v-col cols="12" sm="6" class="d-flex justify-sm-end">
                <BaseButton
                  color="secondary"
                  class="px-0 mr-2 details-proposal__button"
                  @click="onPreviewFile(proposalFile)"
                >
                  <v-icon color="white">
                    fa-file
                  </v-icon>
                </BaseButton>
              </v-col>
            </v-row>
            <v-row class="pa-4 pt-6" v-if="isPolicy">
              <v-col cols="12" sm="6">
                <p
                  class="font-weight-bold "
                >
                  Número da Apólice
                </p>
                <p
                  class="darkBluishGray--text font-weight-medium"
                >
                  {{ form.numero_apolice }}
                </p>
              </v-col>
              <v-col cols="12" sm="6" class="d-flex justify-sm-end">
                <BaseButton
                  color="secondary"
                  class="px-5 mr-1 details-proposal__button"
                  @click="onPreviewFile(policyFile)"
                >
                  <v-icon>
                    fa-file
                  </v-icon>
                  <span class="pl-2">
                    Baixar Apólice
                  </span>
                </BaseButton>
              </v-col>
            </v-row>
          </v-col>
          <v-col>
            <v-row class="details-proposal__item px-3 py-7">
              <v-col cols="12">
                <p
                  class="subtitle-2 font-weight-bold primary--text details-proposal__title-height"
                >
                  Vigência
                </p>
                <div class="time-container">
                  <p
                    class="body-2 primary--text mb-0 details-proposal__title-height"
                  >
                    <span class="time-label">Início:</span> 00:00 de
                    {{ formatIsoDateToDDMMYYYY(form.inicio_vigencia) }}
                  </p>
                </div>
                <div>
                  <p
                    class="body-2 primary--text details-proposal__title-height"
                  >
                    <span class="time-label">Fim:</span> 23:59 de
                    {{ formatIsoDateToDDMMYYYY(form.fim_vigencia) }}
                  </p>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="6" class="pr-md-5 pb-5 pb-md-9">
        <QuotationProposalAgricolaInformation
          v-if="product == 'agricola'"
          :form="form"
        />
        <QuotationProposalCafezalInformation
          v-if="product == 'cafezal'"
          :form="form"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="pr-md-5 pb-md-9 mt-5">
        <QuotationProposalAgricolaCoverage
          v-if="product == 'agricola'"
          :form="form"
        />
        <QuotationProposalCafezalCoverage
          v-if="product == 'cafezal'"
          :form="form"
        />
      </v-col>
    </v-row>
    <v-col cols="12" class="pr-md-5 pb-3 mt-5">
      <v-row class="px-4 pt-3 pb-4 details-proposal__card-auto">
        <v-col cols="12">
          <p class="primary--text font-weight-bold mb-2">
            Formas de Pagamento
          </p>
        </v-col>
        <v-col cols="12" md="6" class="details-proposal__item-auto">
          <v-row class="pa-4">
            <v-col cols="12">
              <p
                class="caption darkBluishGray--text mb-2 font-weight-medium details-proposal__text-height"
              >
                {{ paymentText }}
              </p>
              <p
                class="darkBluishGray--text mb-2 font-weight-medium details-proposal__text-height"
              >
                {{ asMoneyString(loadPayments()) }}
              </p>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="6" class="details-proposal__item-auto">
          <v-row class="px-4 py-6" v-if="!isPolicy">
            <v-col cols="12" class=" d-flex justify-center">
              <BaseButton
                color="secondary"
                class="base-input-file__button px-5"
                @click="onPreviewFile(proposalFile)"
              >
                <v-icon class="pr-3">
                  fa-file
                </v-icon>
                Baixar Proposta
              </BaseButton>
              <BaseButton
                v-if="!isPolicy"
                color="secondary"
                class="base-input-file__button px-5 mx-5"
                @click="onPreviewFile(billingFile)"
              >
                <v-icon class="pr-3">
                  fa-credit-card
                </v-icon>
                Baixar Boleto
              </BaseButton>
            </v-col>
          </v-row>
          <v-row class="py-6 d-flex flex-column align-center" v-if="isPolicy">
            <span
              class="body-2 font-weight-bold primary--text mb-0 details-proposal__title-height"
              >Boletos</span
            >
            <DocumentDataTable
              class="white pb-4 "
              :documents="this.form.boletos"
              @preview-file="onPreviewFile"
              :delete-button="false"
            />
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </div>
</template>


<script>
import DocumentsMixin from "@/mixins/DocumentsMixin";
import {
  asNumberString,
  asMoneyString,
  formatIsoDateToDDMMYYYY
} from "@/utils/formats.js";
import DocumentDataTable from "@/components/DocumentDataTable";
import QuotationProposalAgricolaCoverage from "./QuotationProposalAgricolaCoverage.vue";
import QuotationProposalAgricolaInformation from "./QuotationProposalAgricolaInformation.vue";
import QuotationProposalCafezalCoverage from "./QuotationProposalCafezalCoverage.vue";
import QuotationProposalCafezalInformation from "./QuotationProposalCafezalInformation.vue";
import QuotationFloatActionButton from "../components_agro/QuotationFloatActionButton.vue";
import { mapState } from "vuex";

export default {
  name: "QuotationProposalViewer",
  mixins: [DocumentsMixin],
  components: {
    DocumentDataTable,
    QuotationProposalAgricolaCoverage,
    QuotationProposalAgricolaInformation,
    QuotationProposalCafezalCoverage,
    QuotationProposalCafezalInformation,
    QuotationFloatActionButton
  },
  data() {
    return {
      asMoneyString,
      formatIsoDateToDDMMYYYY,
      closeTable: false,
      asNumberString
    };
  },
  methods: {
    closeTableBillingFile() {
      return (this.closeTable = true);
    },
    loadPayments() {
      let parcel = Number(this.paymentForm.id);
      return (
        parcel +
        "x R$ " +
        asNumberString(
          (this.form.premio_segurado ?? this.form.custo_segurado) / parcel
        )
      );
    }
  },
  computed: {
    ...mapState("me", ["userIsEmployee"]),
    paymentForm() {
      return this.form.forma_pagamento;
    },
    paymentText() {
      if (this.paymentForm == null || this.paymentForm.id === null) {
        return "";
      }

      if (this.paymentForm.id == 1) {
        return "Pagamento à vista";
      }

      return `Parcelado em `;
    },
    hasAditionalCoverage() {
      return this.form.tipo_cobertura?.id === "basica_replantio";
    },
    isProductivity() {
      return this.form.tipo_seguro == "produtividade";
    },
    insuranceCompany() {
      return this.form.seguradora?.nome;
    },
    insuranceType() {
      return this.form.tipo_seguro?.nome;
    },
    claimType() {
      return this.form.tipo_reivindicacao?.nome;
    },
    proposalFile() {
      return {
        url: this.form.arquivo_link
      };
    },
    policyFile() {
      return {
        url: this.form.arquivo_apolice_link
      };
    },
    billingFile() {
      return {
        url: this.form.boleto_link
      };
    },
    quotationCafezal() {
      return this.product == "cafezal"
        ? "details-proposal__item-cafezal"
        : "none";
    },
    getIsEmployeeUser() {
      return this.userIsEmployee;
    },
    infoMessage() {
      return "Consulte as informações e faça o download da proposta e do boleto no final da página. Clique em próximo para realizar a conformidade e acessar a apólice.";
    }
  },
  props: {
    form: {
      type: Object
    },
    isPolicy: {
      type: Boolean,
      default: false
    },
    product: {
      type: String
    }
  }
};
</script>

<style lang="sass">
.details-proposal__
  &title
    align-self: center
  &card
    border: 1px solid #D5D5E0
    border-radius: 2px
    background-color: #F0F0F7
    @media(min-width: 960px)
      min-height: 360px
  &card-auto
    border: 1px solid #D5D5E0
    border-radius: 2px
    background-color: #F0F0F7
  &item
    border: 1px solid #D5D5E0
    border-radius: 4px
    background-color: #FFFFFF
    @media(min-width: 960px)
      height: 120px
  &item-auto
    border: 1px solid #D5D5E0
    border-radius: 4px
    background-color: #FFFFFF
  &button
    min-width: 40px !important
  &border-success
    border-left: 5px solid #49DCBB
  &border-green
    border-left: 5px solid #49DCBB
  &border-yellow
    border-left: 5px solid #FFC55F
  &border-pink
    border-left: 5px solid #EF5350
  &value
    font-size: 12px
    font-weight: 600
  &text-
  &text-height
    line-height: 16px !important
  &title-height
    line-height: 18px !important
  &disclaimer
    @media(min-width: 600px) and (max-width: 960px)
      height: 40px
    @media(min-width: 1440px)
      height: 40px
    border-radius: 4px
  &money
    font-size: 25px
    font-weight: 800
    line-height: 18px
  &table.v-data-table.theme--light
    thead tr th
      padding: 8px 8px
    tbody tr td
      padding: 18px 8px
    tbody tr td:first-child
      padding: 2px 0px !important
  &table-padding
    padding: 0px 15px !important
    height: 36px !important
    display: flex
    align-items: center
  &item-cafezal
    min-height: 360px
    height: 110%
.time-container
  display: flex
  align-items: baseline
.time-label
  width: 3em
  display: inline-block
.messageInfoProposal
  margin-top: -65px
  margin-right: 80px
</style>
